import { BACKEND_URL } from '../../config'
import { get } from '../../common/network-client'

export const fetchAllTrackers = async (offset, limit) => {
  const response = await get(
    `${BACKEND_URL}/tracking/queries/get-active-trackers?offset=${offset}&limit=${limit}`
  )
  return response.data
}
